import { getMessages } from '../../../../../store/constants';

export const PROFILE_GOOGLE = getMessages().getText('profile.tooltip.google');
export const PROFILE_MS = getMessages().getText('profile.tooltip.ms');
